var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchduleYourDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 101,
    viewBox: "0 0 94 101",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 58)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 59.377,
    cy: 23.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.377 0c12.979 0 23.5 10.521 23.5 23.5 0 6.952-3.019 13.199-7.817 17.502H27.694c-4.798-4.303-7.817-10.55-7.817-17.502 0-12.979 10.521-23.5 23.5-23.5z",
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 26.377,
    cy: 23.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 43.377,
    cy: 23.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 59.377,
    cy: 23.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 59.377,
    cy: 23.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 43.377,
    cy: 23.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 43.377,
    cy: 23.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 26.377,
    cy: 23.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D4382A",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 26.377,
    cy: 23.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 21.5h81.753a2 2 0 0 1 1.929 2.53L83.63 31.5a13.604 13.604 0 0 1-13.118 10h-55.27a13.604 13.604 0 0 1-13.118-10L.072 24.03a2 2 0 0 1 1.929-2.53z",
    fill: "#B4321E"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#D4382A",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2h5.012L9.836 4.54a8 8 0 0 0 .403 7.482l1.183 1.97a8 8 0 0 1 .48 7.311l-2.094 4.812a8 8 0 0 0-.025 6.324l1.904 4.476a8 8 0 0 1 .043 6.161l-1.98 4.84a8 8 0 0 0 .205 6.519l2.69 5.55h0M17.213 2l-1.22 2.468a8 8 0 0 0 .314 7.667l1.115 1.856a8 8 0 0 1 .48 7.312l-2.094 4.812a8 8 0 0 0-.025 6.324l1.904 4.476a8 8 0 0 1 .043 6.161l-1.849 4.52a8 8 0 0 0 .47 7.02l1.513 2.628h0M9.098 8.217H6M11.313 13.926h-5M28.313 13.926h-11M28.313 7.926h-13M12.313 20.926h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.213 2H33.67l5.594 4.249 46.345-1.4c4.464.633 6.697 3.098 6.697 7.396 0 4.297-2.233 6.445-6.697 6.445l-46.345-2.8-5.594 4.333H18.79M25.194 20.223l-2.862 6.982a7 7 0 0 0 .17 5.694l1.97 4.086a7 7 0 0 1-.06 6.198l-2.196 4.344a7 7 0 0 0-.191 5.907l.788 1.846h0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchduleYourDelivery);
export default __webpack_public_path__ + "static/media/schdule-your-delivery.bcd88fe618f1f15e360df64f5102507e.svg";
export { ForwardRef as ReactComponent };